module.exports = __webpack_public_path__ + "static/media/Deeksha.96fb572f.svg";